<template>
  <Media size="tight">
    <MediaBody class="pdg-">
      <UserEntity :username="username" layout="inline" :query="query">
        <template v-slot:number="props">
          <mark v-if="props.number === query">{{ props.number }}</mark>
          <template v-else>
            {{ props.number }}
          </template>
        </template>

        <template v-slot:entityname="props">
          <span v-if="props.entityname" v-html="highlight(props.entityname)" />
          <Badge v-if="line" tag="span" size="small" class="mrgl--">
            <mark v-if="line === query">{{ line }}</mark>
            <template v-else>
              {{ line }}
            </template>
          </Badge>
        </template>

        <template v-slot:company="props">
          <span v-if="props.company" v-html="highlight(props.company)" />
        </template>

        <template slot="actions">
          <UserActions :username="username" @call-started="handleCallRequested">
            <template v-slot:line="props">
              <mark v-if="props.line === query">{{ props.line }}</mark>
              <template v-else>
                {{ props.line }}
              </template>
            </template>
          </UserActions>
        </template>
      </UserEntity>
    </MediaBody>

    <CenterMapOnUserBtn
      v-if="['bus', 'inspector'].includes(type)"
      :username="username"
    />
  </Media>
</template>

<script>
import { mapMutations } from 'vuex';

import UserEntity from '@/components/users/UserEntity';
import UserActions from '@/components/users/UserActions';
import CenterMapOnUserBtn from '@/components/map/google/CenterMapOnUserBtn';
import Badge from '@/components/ui/Badge';

export default {
  components: {
    UserEntity,
    UserActions,
    CenterMapOnUserBtn,
    Badge,
  },

  props: {
    username: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
  },

  computed: {
    localUser() {
      return (
        this.user ||
        this.$store.getters['users/getUserByUsername'](this.username) ||
        {}
      );
    },

    line() {
      return (
        this.localUser.details &&
        this.localUser.details.current_course &&
        this.localUser.details.current_course.line
      );
    },
  },

  methods: {
    ...mapMutations('ui', ['setSearchResultsPanelVisibility']),

    handleCallRequested() {
      this.setSearchResultsPanelVisibility(false);
    },

    highlight(text) {
      if (!this.query) return text;
      let array = text.split(' ');

      array.forEach((part, i) => {
        array[i] = part.replace(
          new RegExp(`^[(]?${this.query}[)]?`, 'gi'),
          match => {
            return `<mark>${match}</mark>`;
          }
        );
      });

      return array.join(' ');
    },
  },
};
</script>
